module.exports = __webpack_public_path__ + "static/img/beta_bg_03.944c2073.svg";